import {fetch, rap} from '@/utils/common'
export const actions = {
  handleFetchShoppingCart ({commit}, company) {
    const url = rap({
      list: `/fep/wx/${company.id}/myShoppingCart/list`
    })
    let stationId = window.localStorage.getItem('loginStationId')

    fetch(url.list, {stationId: stationId}).then(res => {
      commit('SHOPPING_LIST_NUM', {
        list: res.data.list
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/mall/actions.js